import type { ComponentType, SVGProps } from 'react';

export type SidebarIcon = ComponentType<SVGProps<SVGSVGElement>>;

export type SidebarNavLeaf = {
  code: string;
  to: string;
  label: string;
  icon: SidebarIcon;
  children?: SidebarNavLeaf[];
};

export type SidebarDepartment = {
  id: string;
  label: string;
  icon: SidebarIcon;
  items: SidebarNavLeaf[];
};

export function flattenSidebarNavPaths(items: readonly SidebarNavLeaf[]): string[] {
  const paths: string[] = [];
  for (const item of items) {
    paths.push(item.to);
    if (item.children?.length) {
      paths.push(...flattenSidebarNavPaths(item.children));
    }
  }
  return paths;
}
